<template>
    <div class="signed-internship">
        <div class="internship-details-header">
            <h2 class="title">{{ internshipIn.name }}</h2>
            <div class="right-side">
                <b-button
                    class="btn-add add-to-bank"
                    v-if="
                        $authUser.hasRoleOrAdmin('internship') &&
                        internshipIn.internship_ownerable_type === 'App\\Models\\User'
                    "
                    variant="primary"
                    @click="showAddToBankModal">
                    <!-- TODO: Rename 'internship_bench' -->
                    {{ $t('internship.add_to_internship_bank') }}
                </b-button>
                <!--            Todo ook hier een activity log van de status modal maar pas na de toevoegen knop af is.-->
                <b-badge
                    class="signed-internship-status-badge"
                    :variant="internshipIn.pivot.status === 2 ? 'success' : 'warning'"
                    pill>
                    <i :class="internshipIn.pivot.status === 2 ? 'icon fas fa-check' : 'icon fad fa-hourglass-half'">
                    </i>
                    {{ internshipIn.pivot.status === 2 ? $t('internship.approved') : $t('internship.in_progress') }}
                </b-badge>
            </div>
        </div>

        <div class="signed-internship-content">
            <div class="signed-internship-main-content">
                <design-2021-apprentice-display-html-component
                    class="internship-details-description"
                    v-html="internshipIn.description">
                </design-2021-apprentice-display-html-component>

                <b-button
                    class="btn-sign-out btn-signed-internship-sign-out d-none d-xl-block"
                    v-if="signedInternshipAgreement === null && $authUser.isStudent()"
                    variant="danger"
                    @click="signoutForInternship">
                    {{ $t('internship.unregister_from_this_internship') }}
                </b-button>
            </div>

            <div class="signed-internship-aside-content">
                <design-2021-internship-report-signed-internship-agreement-upload-component
                    :internship-agreement-in="internshipIn.internship_agreement"
                    :project-in="projectIn"
                    @internship-agreement-stored="showAssignments">
                </design-2021-internship-report-signed-internship-agreement-upload-component>

                <div class="internship-motivation">
                    <h4 class="title">{{ $t('internship.motivation') }}</h4>
                    <div class="text">
                        {{ internshipIn.pivot.motivation }}
                    </div>
                </div>

                <div class="internship-address">
                    <h4 class="title">{{ internshipIn.organization }}</h4>
                    <div class="signed-internship-address">
                        <span class="label">{{ $t('internship.address') }}</span>
                        <span class="address"
                            >{{ internshipIn.street }} {{ internshipIn.streetnumber }}, {{ internshipIn.zipcode }}
                            {{ internshipIn.location }}</span
                        >
                    </div>

                    <div
                        class="signed-internship-supervisor"
                        v-if="internshipIn.supervisor">
                        <span class="label">{{ $t('internship.supervisor') }}</span>
                        <span class="phone-number">{{ internshipIn.supervisor }}</span>
                    </div>

                    <div
                        class="signed-internship-email"
                        v-if="internshipIn.email">
                        <span class="label">{{ $t('common.email') }}</span>
                        <span class="email">{{ internshipIn.email }}</span>
                    </div>

                    <div
                        class="signed-internship-phone"
                        v-if="internshipIn.phone">
                        <span class="label">{{ $t('common.phone') }}</span>
                        <span class="phone-number">{{ internshipIn.phone }}</span>
                    </div>

                    <div
                        class="signed-internship-tags-list"
                        v-if="internshipIn.internship_tags.length">
                        <span class="label">{{ $t('internship.internship_type') }}</span>
                        <div class="tags">
                            <b-badge
                                class="tag"
                                v-for="tag in internshipIn.internship_tags"
                                :key="tag.is"
                                pill
                                variant="primary">
                                {{ tag.name }}
                            </b-badge>
                        </div>
                    </div>

                    <design-2021-apprentice-map-component
                        class="signed-internship-google-map"
                        :address="getInternshipAddress()"
                        :google-map-api="googleMapApi"
                        :title="internshipIn.organization">
                    </design-2021-apprentice-map-component>

                    <b-button
                        class="btn-sign-out btn-signed-internship-sign-out d-block d-xl-none"
                        v-if="
                            !projectIn.signed_internship_agreement &&
                            $authUser.isStudent() &&
                            internshipIn.pivot.status === 2
                        "
                        variant="danger"
                        @click="signoutForInternship">
                        {{ $t('internship.unregister_from_this_internship') }}
                    </b-button>
                </div>
            </div>
        </div>
        <design-2021-internship-student-copy-to-school-bank-modal-component
            @updateInternship="updateInternship($event)"
            :ref="'add-to-bank-modal'">
        </design-2021-internship-student-copy-to-school-bank-modal-component>
    </div>
</template>

<script>
import { AuthUser } from '../../../classes/auth/AuthUser';

export default {
    name: 'design-2021-internships-student-signed-internship-component',
    computed: {
        AuthUser() {
            return AuthUser;
        },
    },
    props: {
        internshipIn: {
            type: Object,
            required: true,
        },
        projectIn: {
            type: Object,
            required: true,
        },
        googleMapApi: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            signedInternshipAgreement: this.projectIn.signed_internship_agreements.length
                ? this.projectIn.signed_internship_agreements[0]
                : null,
        };
    },

    methods: {
        getOwnerTypeClass(model) {
            switch (model) {
                case 'App\\Models\\User':
                    return 'fad fa-user-crown';

                case 'App\\Models\\Organization\\Organization':
                case 'App\\Models\\School':
                    return 'fad fa-university';
            }
        },

        getOwnerTypeText(model) {
            switch (model) {
                case 'App\\Models\\User':
                    return this.$t('internship.personal_internship');

                case 'App\\Models\\Organization\\Organization':
                    return this.$t('internship.external_internship');

                case 'App\\Models\\School':
                    return this.$t('internship.school_internship');
            }
        },

        signoutForInternship() {
            this.axios.delete(this.routes.studentInternshipSignout(this.projectIn.id)).then(
                (response) => {
                    this.$emit('signOut');
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getInternshipAddress() {
            return {
                street: this.internshipIn.street,
                number: this.internshipIn.number,
                zipcode: this.internshipIn.zipcode,
                location: this.internshipIn.location,
            };
        },

        showAssignments(agreementFile) {
            this.signedInternshipAgreement = agreementFile;
        },

        showAddToBankModal() {
            this.$refs['add-to-bank-modal'].show(this.internshipIn);
        },

        updateInternship(internship) {
            this.$emit('updateInternship', internship);
        },
    },

    watch: {
        signedInternshipAgreement: function (value) {
            this.signedInternshipAgreement = value;
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    font-family: $headings-font-family;
}

.internship-details-header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: map-get($grid-gutter-spacing, 'ten') $grid-gutter-width;
    align-items: center;
    justify-content: space-between;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .title {
        margin-bottom: 0;
        font-family: $headings-font-family;
    }

    .right-side {
        display: flex;
        flex-wrap: wrap;
        gap: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
        align-items: center;
        justify-content: flex-end;
        flex: 1 1 auto;
        align-self: baseline;
    }

    .signed-internship-status-badge {
        color: $text-color;
        font-size: $default-font-size;
        font-weight: $font-weight-bold;
        padding-top: map-get($grid-gutter-spacing, 'four');
        padding-bottom: map-get($grid-gutter-spacing, 'four');

        .icon {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.btn-signed-internship-sign-out {
    width: 100%;
    margin-top: map-get($grid-gutter-spacing, 'sixty');
}

.signed-internship-content {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
}

.signed-internship-main-content {
    margin-bottom: map-get($grid-gutter-spacing, 'sixty');
}

.internship-agreement,
.internship-motivation {
    margin-bottom: map-get($grid-gutter-spacing, 'sixty');
}

.internship-motivation {
    margin-bottom: $grid-gutter-width;

    .text {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
    }
}

.signed-internship-address,
.signed-internship-phone,
.signed-internship-supervisor,
.signed-internship-email,
.signed-internship-tags-list {
    margin-bottom: map-get($grid-gutter-spacing, 'eight');

    span {
        font-weight: $font-weight-medium;

        &.label {
            display: inline-block;
            width: 120px;
            margin-bottom: 0;
        }

        .signed-internship-status-badge {
            margin-left: auto;
            color: $text-color;
            font-size: $default-font-size;
            font-weight: $font-weight-bold;
            padding-top: map-get($grid-gutter-spacing, 'four');
            padding-bottom: map-get($grid-gutter-spacing, 'four');

            .icon {
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }
        }
    }
}

.signed-internship-tags-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.tags {
    display: flex;
    flex-wrap: wrap;
    column-gap: map-get($grid-gutter-spacing, 'ten');
    row-gap: map-get($grid-gutter-spacing, 'ten');

    .tag {
        font-weight: $font-weight-normal;
        line-height: 1.1;
        font-size: 0.8125rem;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .btn-signed-internship-sign-out {
        width: auto;
        margin: map-get($grid-gutter-spacing, 'sixty') auto 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .signed-internship-content {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
    }

    .signed-internship-main-content {
        flex: 0 1 calc(67% - 36px);
    }

    .signed-internship-aside-content {
        flex: 0 1 calc(33% - 36px);
    }
}

@media (min-width: map-get($grid-breakpoints, 'xxl')) {
    .internship-details-header {
        .title {
            flex: 1 1 calc(100% - 430px);
        }
    }
}
</style>
